<template>
    <div class="form-group row">
        <label :for="name" class="col-sm-1 col-form-label" v-if="icon!=undefined"><i :class="icon"></i></label>
        <div class="col-sm-11">
            <md-field>
                <label>{{name}} </label>
                <md-input
                        :class="{ 'is-invalid':validate && validate.$dirty && validate.$invalid && !disabled}"
                        :disabled="disabled"
                        :id="name"
                        :required="required"
                        :type="typeInput"
                        @focusout="handleFocusOut"
                        @input="sendToParent"
                        class="form-control"
                        v-model="val"
                ></md-input>


            </md-field>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.required == false
              && validate.$dirty == true
               && validate.$error == true }" class="invalid-feedback"
                 v-if="!disabled">
                {{titles.fieldIsRequired}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.minValue == false }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('minValue') && !disabled">
                {{titles.errorMinValue(validate.$params.minValue.min)}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.minValue == false }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('maxValue') && !disabled">
                {{titles.errorMaxValue(validate.$params.maxValue.max)}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.email == false
              && validate.$dirty== true
              && validate.$error == true }" class="invalid-feedback"
                 v-if="!disabled">
                {{titles.invalidEmail}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.mustBeValidPassword == false
              && validate.$dirty== true
              && validate.$error == true }"
                 class="invalid-feedback">
                {{titles.invalidPasswordMessage}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.url == false
              && validate.$dirty== true
              && validate.$error == true }" class="invalid-feedback"
                 v-if="!disabled">
                {{titles.errorFormatUrl}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate
             && validate.numeric == false
              && validate.$dirty== true
              && validate.$error == true }" class="invalid-feedback"
                 v-if="!disabled">
                {{titles.errorFormatNumeric}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate != undefined
            && validate.minLength == false
            && validate.$dirty== true
            && validate.$error == true }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('minLength') && !disabled">
                {{titles.errorLengthName(validate.$params.minLength.min)}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate != undefined
            && validate.maxLength == false
            && validate.$dirty== true
            && validate.$error == true }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('maxLength') && !disabled">
                {{titles.errorLengthNameMax(validate.$params.maxLength.max)}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate != undefined
            && validate.decimal == false
            && validate.$dirty== true
            && validate.$error == true }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('decimal') && !disabled">
                {{titles.decimal}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate != undefined  && validate.checkExistLabel == false
                    && validate.$dirty== true  && validate.$error == true }"
                 class="invalid-feedback" v-if="validate && validate.hasOwnProperty('checkExistLabel') && !disabled">
                {{titles.checkExistLabel}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate != undefined
            && validate.checkDecimalNumber == false
            && validate.$dirty== true
            && validate.$error == true }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('checkDecimalNumber') && !disabled">
                {{titles.checkDecimalNumber}}
            </div>
            <div :class="{ 'invalid-feedback-erreur': validate != undefined
            && validate.$dirty== true
            && validate.$error == true }" class="invalid-feedback"
                 v-if="validate && validate.hasOwnProperty('sameAsPassword') && !disabled">
                {{titles.passwordNotSame}}
            </div>
        </div>
        <span style="display: none" v-if="validate">{{validate.$model}}</span>
    </div>
</template>

<script>

    import {titles} from '../../utils/general/titles';

    export default {
        name: 'Input',
        props: {
            name: String,
            icon: String,
            inputKey: String,
            validate: Object,
            type: String,
            disabled: {
                type: Boolean,
                default: false
            },
            forcedVal: String,
            decimalDigits: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                titles,
                val: this.validate ? this.validate.$model : this.forcedVal ? this.forcedVal : null,
                typeInput: this.type ? this.type : 'text',
                required: this.validate != undefined && this.validate.required != undefined
            };
        },
        methods: {
            sendToParent() {
                this.typeInput == 'number' ? this.val = parseInt(this.val, 0) : this.val;
                this.$emit('method', this.inputKey, this.val);
            },
            handleFocusOut() {
                if (this.validate && this.validate.checkDecimalNumber) {
                    this.val = parseFloat(this.validate.$model, 0).toFixed(this.decimalDigits);
                }
            }
        },
        updated() {
            this.val = this.validate ? this.validate.$model : this.forcedVal ? this.forcedVal : null;
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
